import Vue from 'vue'

Vue.prototype.$response = {
  Ok: 200,
  Created: 201,


  BadRequest: 400,
  Unauthorized: 401,


  Forbidden: 403,
  NotFound: 404,



  Conflict: 409,
  UnprocessableEntity: 422,

}
